import { observable, computed, action } from 'mobx';

import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Summary from './Summary';
import { post } from '../../../services/request';

export default class Store {
  steps = [
    { key: 'winner', title: 'Choose a winner', implementation: Step1 },
    { key: 'message', title: 'Message to winner', implementation: Step3 },
    { key: 'reject', title: 'Choose offers to reject', implementation: Step2 },
    {
      key: 'reject-message',
      title: 'Message to rejected',
      implementation: Step4,
    },
  ];

  getSteps() {
    return this.steps
      .filter(
        (step) =>
          step.key !== 'reject' || this.eligibleOffersForWinner.length > 1
      )
      .filter(
        (step) =>
          step.key !== 'reject-message' ||
          this.eligibleOffersForWinner.length > 1
      );
  }

  @observable offers;

  @observable rejectedOffers = [];

  @observable selectedBuyerId;

  @observable message = '';

  @observable rejectMessage = '';

  summaryClass = Summary;

  @computed get selectedBuyer() {
    if (!this.offers) return [];
    return (
      this.offers.filter((o) => o.buyerId === this.selectedBuyerId)[0] || {}
    );
  }

  @computed get eligibleOffersForWinner() {
    if (!this.offers) return [];

    return this.offers
      .filter(
        (item) =>
          item.status === 'confirmed' ||
          item.status === 'accepted' ||
          item.status === 'awarded'
      )
      .sort((a, b) => b.submittedValue - a.submittedValue);
  }

  @computed get eligibleOffersToReject() {
    if (!this.offers) return [];

    return this.offers
      .filter(
        (item) =>
          item.buyerId !== this.selectedBuyerId &&
          (item.status === 'confirmed' ||
            item.status === 'accepted' ||
            item.status === 'awarded')
      )
      .sort((a, b) => b.submittedValue - a.submittedValue);
  }

  @computed get rejectedOfferDetails() {
    var lookup = this.offers.reduce((acc, i) => {
      acc[i.buyerId] = i;
      return acc;
    }, {});
    return this.rejectedOffers.map((o) => lookup[o]);
  }

  constructor(management) {
    this.offers = management.source.offers.viewModel.offers.map((item) => {
      return {
        item,
        buyerId: item.buyerId,
        name: `${item.buyer.buyer_lastName}, ${item.buyer.buyer_firstName}`,
        submittedValue: item.submittedValue,
        validity: item.data.offer_validity,
        status: item.status,
      };
    });
  }

  handleMessageChange = action((value) => {
    this.message = value;
  });

  handleRejectMessageChange = action((value) => {
    this.rejectMessage = value;
  });

  @action async submit(saleId, token) {
    await post(
      `/api/v1/wizard/${saleId}/award`,
      {
        rejectOffers: this.rejectedOffers,
        buyerId: this.selectedBuyerId,
        message: this.message,
        rejectMessage: this.rejectMessage,
      },
      token
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/Award/index.js